let isApplication = false;

document.addEventListener('DOMContentLoaded', function() {
  const formSlug = document.querySelector('input[name="form_slug"]').value;
  const form = document.querySelector('.contact-form__form');
  const formButton = document.querySelector('.contact-form__button'); 
  const formWarning = document.querySelector('.formWarning');

  formWarning.style.color = '#ff0000';
  formWarning.style.display = 'none';

  if (formSlug == 'contact') {
    sendURL = "/b2b/send-contact.php";
    thanksURL = "/pages/contact-thank-you";

    if (window.customer.isLoggedIn) {
        document.querySelector('input[name="contact[Name]"]').value = window.customer.name;
        document.querySelector('input[name="contact[Phone]"]').value = window.customer.phone;
        document.querySelector('input[name="contact[Company]"').value = window.customer.company;
    }

    
  } else if (formSlug == 'application') {

    sendURL = "/b2b/send-application.php";
    thanksURL = "/pages/application-thank-you";

    // By default, hide all of the application fields
    setApplicationFieldsHidden(true);

    // Add change event listener to each radio button
    const radioButtons = document.querySelectorAll('input[type="radio"][name="contact[How can we help you? *]"]');
    radioButtons.forEach(radio => {
      radio.addEventListener('change', (event) => {
        if (event.target.checked) {
          if (event.target.value == 'I would like to apply as a customer') {
            isApplication = true;
            setApplicationFieldsHidden(false);
            toggleCommentFieldRequired(false);
          } else {
            isApplication = false;
            setApplicationFieldsHidden(true);
            toggleCommentFieldRequired(true);
          }              
        }
      });
    });

  }

  // Handle when the form button is clicked
  formButton.addEventListener('click', function(e) {    
    let isComplete=true;
    const formData = new FormData(form);

    // check for required fields
    if (formSlug == 'contact') {

      if (formData.get('contact[email]') == '' || formData.get('contact[What is your reason for contacting]') == '- Please select one -' || formData.get('contact[Message]') == '') {
        isComplete = false;
      }
      
    } else if (formSlug == 'application') {
      
      formData.append('isApplication', isApplication);
      if (formData.get('contact[How can we help you? *]') == null) {
        isComplete=false; 
      }
      if (
        formData.get('contact[First Name]') == '' ||
        formData.get('contact[Last Name]') == '' ||
        formData.get('contact[Email]') == '' ||
        formData.get('contact[Phone]') == ''
      ) {
        isComplete=false;
      }
      
      // Make sure required fields are filled in (different for application vs. non-application)
      if (isApplication) {
        if (
          formData.get('contact[Street Address]') == '' ||
          formData.get('contact[City]') == '' ||
          formData.get('contact[Province]') == '' ||
          formData.get('contact[Postal Code]') == '' ||
          formData.get('contact[Store / Company Name]') == '' ||
          (formData.get('contact[LP]') != 'on' && formData.get('contact[CD]') != 'on' && formData.get('contact[Cassette]') != 'on' && formData.get('contact[Blu-Ray/DVD]') != 'on' ) ||
          formData.get('contact[Retail Channel]') == '- Select One -'
        ) {
          isComplete=false;
        }          
      } else {
        if (formData.get('contact[Additional questions or comments]') == '') {
          isComplete=false;
        }
      }

    }
    
    if (!isComplete) {
      formButton.disabled = false;
      formWarning.style.display = 'block';
    } else {
      formButton.disabled = true;
    
      // const formData = new FormData(form);
    
      fetch(`https://store.warnermusiccanada.com${sendURL}`, {
         method: 'POST',
         body: formData
      })
      .then(response => response.json())
      .then(data => {
         document.location.href=thanksURL;
      })
      .catch(error => {
         // Handle error
         console.error('Error:', error);
      });
    }
    
  });
  
});


function setApplicationFieldsHidden(isHidden) {
  document.querySelectorAll('.application-field').forEach(element => {
    element.style.display = isHidden ? 'none' : 'block';
  });  
}

function toggleCommentFieldRequired(required) {
  let parent = document.querySelector('textarea[name="contact[Additional questions or comments]"]').parentNode;
  let label = parent.querySelector('label');
  if (required) {
    label.querySelector('span').style.display = 'inline';  
  } else {
    label.querySelector('span').style.display = 'none';      
  }
}